<template>
<div class="text-center alert status-state m-0"
	:class="{
		'alert-success': !serviceStatusIncompleteGroup,
		'alert-warning': serviceStatusIncompleteGroup
	}">{{status}}
</div>
</template>
<script type="text/javascript">

import ServiceMixins from "@/mixins/ServiceMixins.js"

export default {
	name: "ServiceStatusLabel",
	mixins: [ServiceMixins],
	props: ["status"],
}
</script>
<style type="text/css" scoped>
.status-state {
	font-size: 18pt;
	text-transform: uppercase;
	padding: 2px;
	padding-left: 10px;
	padding-right: 10px;
	max-width: 400px;
}
</style>